<template>
  <svg
    :class="size"
    viewBox="0 0 48 48"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38 6H10C7.8 6 6 7.8 6 10V38C6 40.2 7.8 42 10 42H30V38H12C10.9 38 10 37.1 10 36V12C10
         10.9 10.9 10 12 10H36C37.1 10 38 10.9 38 12V30H42V10C42 7.8 40.2 6 38 6ZM38 36C38 37.1
         37.1 38 36 38H38V36ZM24 34C22.9 34 22 33.1 22 32V16C22 14.9 22.9 14 24 14C25.1 14 26 14.9
         26 16V32C26 33.1 25.1 34 24 34ZM16 34C14.9 34 14 33.1 14 32V22C14 20.9 14.9 20 16 20C17.1
         20 18 20.9 18 22V32C18 33.1 17.1 34 16 34ZM30 32C30 33.1 30.9 34 32 34C33.1 34 34 33.1 34
         32V28C34 26.9 33.1 26 32 26C30.9 26 30 26.9 30 28V32Z"
    />
    <path
      d="M39 32C35.136 32 32 35.136 32 39C32 42.864 35.136 46 39 46C42.864 46 46 42.864 46
         39C46 35.136 42.864 32 39 32Z"
    />
    <path
      d="M38.9998 39.7C38.6148 39.7 38.2998 39.385 38.2998 39V36.2C38.2998 35.815 38.6148
         35.5 38.9998 35.5C39.3848 35.5 39.6998 35.815 39.6998 36.2V39C39.6998 39.385
         39.3848 39.7 38.9998 39.7Z"
      fill="white"
    />
    <path
      d="M39.6998 42.5001H38.2998V41.1001H39.6998V42.5001Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#223448',
    },
    size: {
      type: String,
      default: 'large', // small
    },
  },
};
</script>
<style scoped>
svg.large {
  width: 24px;
  height: 24px;
}

svg.small {
  width: 16px;
  height: 16px;
}
</style>
